import createTheme from '../lib/react-storefront/theme/createTheme'
import { red } from '@material-ui/core/colors'

// Create a theme instance.
const theme = createTheme({
  palette: {
    // primary: {
    //   main: '#143862',
    //   contrastText: '#fff',
    // },
    // secondary: {
    //   main: '#E1341E',
    // },
    error: {
      main: red.A400,
    },
    // background: {
    //   default: '#fff',
    // },
  },
  overrides: {},
})

export default theme
